// import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
import { useMemo } from "react";
// import { RootState } from "@/store";
// import { useMemo } from "react";
// import { useSelector } from "react-redux";

export default function AuthErrorPage() {
  // const user = useSelector(
  //   (root: RootState) => root.rootReducer.userReducer.user
  // );

  // const isAuth = useMemo(() => {
  //   const user = JSON.parse(localStorage.getItem("user") + "");
  //   return user && user.subscription_details?.status == "active";
  // }, []);

  // if (isAuth) {
  //   // If the user is not authenticated, redirect to the login page
  //   window.history.back();
  //   return null;
  // }
  const isAuth = useMemo(() => {
    const user = JSON.parse(localStorage.getItem("user") + "");
    // if (localUser) {
    // console.log("local user", localUser);
    // dispatch(setUser(localUser));
    // }
    return user && user.subscription_details?.status == "active";
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-transparent p-4">
      <div className="mx-auto max-w-xl text-center bg-white p-8 rounded-lg shadow-lg">
        <div className="mb-6 flex justify-center">
          <svg
            width="220"
            height="166"
            viewBox="0 0 220 166"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="19" cy="35" r="5" fill="#EAEEF9" />
            <circle cx="9" cy="122" r="9" fill="#EAEEF9" />
            <circle cx="205" cy="28" r="6" fill="#EAEEF9" />
            <circle cx="110" cy="80" r="80" fill="#EAEEF9" fill-opacity=".6" />
            <g filter="url(#lze9o4bhya)">
              <rect
                x="27"
                y="22"
                width="166"
                height="104"
                rx="6"
                fill="url(#7dsklrzsmb)"
              />
              <rect
                x="41.07"
                y="46.185"
                width="29.023"
                height="21.767"
                rx="2"
                fill="#D5DDEA"
              />
              <circle cx="166.837" cy="53.443" r="12.093" fill="#989FB0" />
              <circle cx="152.325" cy="53.443" r="12.093" fill="#D5DDEA" />
              <path
                d="M41.07 110.278a2.419 2.419 0 0 1 2.419-2.419h24.186a2.419 2.419 0 0 1 0 4.838H43.489a2.419 2.419 0 0 1-2.419-2.419zM77.35 110.278a2.419 2.419 0 0 1 2.418-2.419h24.186a2.419 2.419 0 1 1 0 4.838H79.768a2.419 2.419 0 0 1-2.419-2.419zM113.628 110.278a2.419 2.419 0 0 1 2.419-2.419h24.186a2.419 2.419 0 1 1 0 4.838h-24.186a2.419 2.419 0 0 1-2.419-2.419zM149.908 110.278a2.418 2.418 0 0 1 2.418-2.419h24.186a2.419 2.419 0 1 1 0 4.838h-24.186a2.418 2.418 0 0 1-2.418-2.419z"
                fill="#D5DDEA"
              />
            </g>
            <path
              d="M188.304 102c2.309-4 8.083-4 10.392 0l18.62 32.25c2.309 4-.578 9-5.196 9h-37.24c-4.618 0-7.505-5-5.196-9l18.62-32.25z"
              fill="url(#d7agjc95vc)"
            />
            <path
              d="M191.256 134.25a2.75 2.75 0 1 1 5.5-.001 2.75 2.75 0 0 1-5.5.001zm.269-16.514a2.492 2.492 0 0 1 2.475-2.75 2.491 2.491 0 0 1 2.475 2.75l-.962 9.645a1.519 1.519 0 0 1-3.025 0l-.963-9.645z"
              fill="#fff"
            />
            <circle cx="209" cy="4" r="4" fill="#EAEEF9" />
            <defs>
              <linearGradient
                id="7dsklrzsmb"
                x1="32.781"
                y1="124.769"
                x2="29.758"
                y2="29.584"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#EDF0F6" />
                <stop offset="1" stop-color="#FCFDFF" />
              </linearGradient>
              <linearGradient
                id="d7agjc95vc"
                x1="193.5"
                y1="59.5"
                x2="126.5"
                y2="126.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF8960" />
                <stop offset="1" stop-color="#FF62A5" />
              </linearGradient>
              <filter
                id="lze9o4bhya"
                x="7"
                y="22"
                width="206"
                height="144"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="4"
                  in="SourceAlpha"
                  result="effect1_dropShadow_2820_10724"
                />
                <feOffset dy="8" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
                <feBlend
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2820_10724"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="4"
                  in="SourceAlpha"
                  result="effect2_dropShadow_2820_10724"
                />
                <feOffset dy="20" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
                <feBlend
                  in2="effect1_dropShadow_2820_10724"
                  result="effect2_dropShadow_2820_10724"
                />
                <feBlend
                  in="SourceGraphic"
                  in2="effect2_dropShadow_2820_10724"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>

        <h1 className="mb-3 text-xl font-semibold text-gray-800">
          Get Access to This Feature
        </h1>

        <p className="mb-6 text-gray-600">
  {isAuth
    ? "It looks like you don't have access to this module.To unlock access, please get in touch with the administrator."
    : "It looks like you don't have an active subscription plan at the moment. To unlock access, please get in touch with the administrator."}
</p>

         <ScheduleDemo forceOpenOnClick={true}>
        <Button className="bg-green-500 px-6 hover:bg-green-600 mx-auto">
          Contact Administrator
        </Button>
        </ScheduleDemo>
      </div>
    </div>
  );
}
